






import Vue from 'vue';
import { onErrorCaptured } from '@/helpers/sentryHelpers';

export default Vue.extend({
  name: 'ErrorBoundary',
  components: {
    //
  },
  data(): {
    //
  } {
    return {
      //
    };
  },
  /**
   * `errorCaptured` only capture error from children, need to wrap App.vue as child so that any error on App.vue can be capture by Sentry.
   * 
   * GQL requests are handled by vue-apollo library and has its own error handler,
   * in theory none of those error will trigger this hook. Thus, none of the server api error
   * shall be sent to Sentry by dashboard.
   */
  errorCaptured(err) {
    onErrorCaptured(err, this);
  },
});
